import { Navigate, useLocation } from "react-router-dom";
import { ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";

const AdminRoute = ({ children }: { children: ReactNode }) => {
  const { user, loading, isAdmin, rolesLoaded } = useAuth();
  const location = useLocation();

  if (loading || (user && !rolesLoaded)) {
    return (
      <div className="pt-32 min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground font-mono text-xs uppercase tracking-widest">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!isAdmin) {
    return (
      <div className="pt-32 min-h-screen flex items-center justify-center px-4">
        <div className="bg-panel border border-border p-8 max-w-md text-center">
          <h1 className="text-2xl font-display tracking-widest mb-3">ACCESS DENIED</h1>
          <p className="text-muted-foreground font-body text-sm">
            Your account does not have admin permissions.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AdminRoute;
